import {
    IListResponse,
    IServiceTypeData,
    IServiceTypeFilterData,
    ISolutionData,
    IServiceTypePriceReverseData,
    IRequestServiceData,
    IRequestExtended, IRequestServicePostData, IContactData, IRequestServiceHistoryData, ISolutionFilterData
} from '@/entities'
import {
    IServiceService
} from './index'
import {
    AxiosInstance,
    AxiosResponse
} from 'axios'
import {
    defaultConfig
} from '../config'


export class ServiceService implements IServiceService {
    constructor(private readonly axios: AxiosInstance) {}

    async getAllTypes(data?: IServiceTypeFilterData, language?: string): Promise<AxiosResponse<IListResponse<IServiceTypeData[]>>> {
        return this.axios.get('/service_type/', {
            ...defaultConfig(language),
            params: data
        })
    }

    async getTypeById(id: number, language?: string): Promise<AxiosResponse<IServiceTypeData | undefined>> {
        return this.axios.get(`/service_type/${ id }/`, defaultConfig(language))
    }

    async getAllTypePrices(data?: IServiceTypeFilterData, language?: string): Promise<AxiosResponse<IListResponse<IServiceTypePriceReverseData[]>>> {
        return this.axios.get('/service_type_priced/', {
            ...defaultConfig(language),
            params: data
        })
    }

    async getTypePriceById(id: number, language?: string): Promise<AxiosResponse<IServiceTypePriceReverseData | undefined>> {
        return this.axios.get(`/service_type_priced/${ id }/`, defaultConfig(language))
    }

    async getAllSolutions(data?: ISolutionFilterData, language?: string): Promise<AxiosResponse<IListResponse<ISolutionData[]>>> {
        return this.axios.get('/solution/', {
            ...defaultConfig(language),
            params: data
        })
    }

    async getSolutionById(id: number, language?: string): Promise<AxiosResponse<ISolutionData | undefined>> {
        return this.axios.get(`/solution/${ id }/`, defaultConfig(language));
    }

    async setRequestServiceContact(data: IRequestExtended<IRequestServicePostData>, language?: string): Promise<AxiosResponse<IContactData>> {
        return this.axios.patch(
          `/request_service/${ data.key }/update_contact/`,
          data.payload,
          {
              ...defaultConfig(language),
              ...data.config
          })
    }

    async getRequestServiceHistories(data: IRequestExtended): Promise<AxiosResponse<IListResponse<IRequestServiceHistoryData[]>>> {
        return this.axios.get(`/request_service/${ data.key }/history/`, {
            ...defaultConfig(),
            ...data.config
        })
    }
}
